import ReactionBadge from "src/components/ReactionBadge";
import { useGatheringStore } from "src/contexts/GatheringContext";
import useGatheringReactionAsset from "src/hooks/useGatheringReactionAsset";

const ReactionDisplay = ({ numPrimaryReaction }: { numPrimaryReaction: number }) => {
	const gatheringId = useGatheringStore((state) => state.gatheringId);
	const { reactionAsset } = useGatheringReactionAsset(gatheringId);

	if (!reactionAsset) return null;
	return (
		<ReactionBadge reactionAsset={reactionAsset} count={numPrimaryReaction} sizeVariant="sm" />
	);
};
export default ReactionDisplay;
